"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var recompose_1 = require("recompose");
var styled_components_1 = require("styled-components");
var contexts_1 = require("../../contexts");
var Box_1 = require("../Box");
var Link_1 = require("../Link");
var Text_1 = require("../Text");
var CheckBox_1 = require("../CheckBox");
var themes_1 = require("../../themes");
var StyledCard_1 = require("./StyledCard");
var react_1 = require("react");
var CardInner = function (_a) {
    var id = _a.id, actionCard = _a.actionCard, featureCard = _a.featureCard, checkboxCard = _a.checkboxCard, detailedcheckedBox = _a.detailedcheckedBox, details = _a.details, icon = _a.icon, title = _a.title, action = _a.action, text = _a.text, actionLink = _a.actionLink, image = _a.image, imageHeight = _a.imageHeight, isFullCardClickable = _a.isFullCardClickable, _b = _a.large, large = _b === void 0 ? false : _b, _c = _a.checked, checked = _c === void 0 ? false : _c;
    var _d, _e, _f, _g, _h, _j, _k, _l, _m;
    var hasValidLink = !!actionLink && !!actionLink.title && (!!actionLink.href || !!actionLink.action);
    var _o = React.useState(checked), cardChecked = _o[0], setCardChecked = _o[1];
    var _p = React.useState(checked), detailedCardChecked = _p[0], setDetailedCardChecked = _p[1];
    react_1.useEffect(function () {
        setDetailedCardChecked(checked);
    }, [checked]);
    var handleCardClick = function () {
        if (checkboxCard) {
            setCardChecked(!cardChecked);
        }
        if (detailedcheckedBox) {
            setDetailedCardChecked(!detailedCardChecked);
        }
        if (!isFullCardClickable) {
            // full card is not configured to be clickable
            return;
        }
        if (!hasValidLink) {
            console.warn('Card configured as clickable but not action provided');
            return;
        }
        if (actionLink.action) {
            actionLink.action();
        }
        if (actionLink.href) {
            window.location.href = actionLink.href;
        }
    };
    if (checkboxCard) {
        var MainIcon = icon.icon;
        return (React.createElement(StyledCard_1.StyledCard, { id: id, "data-testid": "checkboxCard", checkboxCard: checkboxCard, onClick: handleCardClick, isFullCardClickable: !!isFullCardClickable },
            React.createElement(Box_1.Box, { background: "white", round: "4px", align: "center", alignContent: "center", shadow: "0 1px 2px 0 rgba(0, 0, 0, 0.1)", border: {
                    color: '#DFE0E2',
                    side: 'all'
                }, pad: "medium", height: "104px", onClick: action, direction: "row" },
                React.createElement(StyledCard_1.StyledCheckboxBox, { margin: { vertical: 'auto', right: 'small' }, className: "outterBox" },
                    React.createElement(CheckBox_1.CheckBox, { checked: cardChecked, readOnly: true, margin: "0", className: "checkbox" })),
                React.createElement(StyledCard_1.StyledCheckboxIconBox, { margin: { right: 'small' } },
                    React.createElement(MainIcon, null)),
                React.createElement(StyledCard_1.StyledCheckboxTextBox, { margin: { vertical: 'auto' } },
                    React.createElement(Text_1.Text, { size: 'medium', weight: 'bold', color: themes_1.colors.secondaryText.light }, text)))));
    }
    if (detailedcheckedBox) {
        var MainIcon = icon.icon;
        return (React.createElement(StyledCard_1.StyledCard, { id: id, "data-testid": "detailedcheckedBox", checkboxCard: detailedcheckedBox, onClick: handleCardClick, isFullCardClickable: !!isFullCardClickable },
            React.createElement(Box_1.Box, { background: "white", round: "4px", align: "center", alignContent: "center", shadow: "0 1px 2px 0 rgba(0, 0, 0, 0.1)", border: {
                    color: '#DFE0E2',
                    side: 'all'
                }, pad: "small", minHeight: "104px", onClick: action, direction: "row" },
                React.createElement(StyledCard_1.StyledCheckboxBox, { margin: { vertical: 'auto', right: 'small' }, className: "outterBox" },
                    React.createElement(CheckBox_1.CheckBox, { checked: detailedCardChecked, readOnly: true, margin: "0", className: "checkbox" })),
                React.createElement(StyledCard_1.StyledCheckboxIconBox, { margin: { right: 'small' } },
                    React.createElement(MainIcon, null)),
                React.createElement(Box_1.Box, { direction: "column" },
                    React.createElement(Box_1.Box, { margin: { vertical: 'auto' } },
                        React.createElement(Text_1.Text, { size: 'medium', weight: 'bold', color: themes_1.colors.secondaryText.light }, (_d = details) === null || _d === void 0 ? void 0 : _d.heading)),
                    React.createElement(Box_1.Box, { margin: { vertical: 'auto' } },
                        React.createElement(Box_1.Box, { direction: "row", width: "medium" },
                            React.createElement(Text_1.Text, null,
                                React.createElement(Text_1.Text, { size: 'small', weight: 'bold', color: themes_1.colors.secondaryText.light }, (_f = (_e = details) === null || _e === void 0 ? void 0 : _e.firstLine) === null || _f === void 0 ? void 0 :
                                    _f.key, ": "),
                                React.createElement(Text_1.Text, { size: 'small', color: themes_1.colors.secondaryText.light }, (_h = (_g = details) === null || _g === void 0 ? void 0 : _g.firstLine) === null || _h === void 0 ? void 0 : _h.value)))),
                    React.createElement(Box_1.Box, { margin: { vertical: 'auto' } },
                        React.createElement(Box_1.Box, { direction: "row", width: "large" },
                            React.createElement(Text_1.Text, null,
                                React.createElement(Text_1.Text, { size: 'small', weight: 'bold', color: themes_1.colors.secondaryText.light }, (_k = (_j = details) === null || _j === void 0 ? void 0 : _j.secondLine) === null || _k === void 0 ? void 0 :
                                    _k.key, ": "),
                                React.createElement(Text_1.Text, { size: 'small', color: themes_1.colors.secondaryText.light }, (_m = (_l = details) === null || _l === void 0 ? void 0 : _l.secondLine) === null || _m === void 0 ? void 0 : _m.value))))))));
    }
    if (actionCard) {
        var MainIcon = icon.icon;
        return (React.createElement(StyledCard_1.StyledCard, { id: id, "data-testid": "actionCard", actionCard: actionCard, onClick: handleCardClick, isFullCardClickable: !!isFullCardClickable },
            React.createElement(Box_1.Box, { background: "white", round: "4px", align: "center", alignContent: "center", shadow: "0 1px 2px 0 rgba(0, 0, 0, 0.1)", pad: "medium", onClick: action },
                React.createElement(Box_1.Box, { direction: "column", gap: "medium" },
                    React.createElement(MainIcon, null),
                    React.createElement(Text_1.Text, { size: 'medium', weight: 900 }, title)))));
    }
    if (featureCard) {
        return (React.createElement(contexts_1.ResponsiveContext.Consumer, null, function (size) { return (React.createElement(StyledCard_1.StyledCard, { id: id, "data-testid": "featureCard", featureCard: featureCard, onClick: handleCardClick, isFullCardClickable: !!isFullCardClickable },
            React.createElement(StyledCard_1.StyledBox, { background: "white", round: "4px", shadow: "0 2px 4px 0 rgba(0, 0, 0, 0.1)" },
                React.createElement(StyledCard_1.StyledCardImage, { image: image, imageHeight: imageHeight }),
                React.createElement(StyledCard_1.StyledBox, { pad: { horizontal: 'medium', vertical: 'small' } },
                    React.createElement(StyledCard_1.StyledText, { size: large ? 'large' : 'medium', weight: 'normal', font: 'AvenirLTPro-Heavy', clampLines: 2 }, text),
                    React.createElement("span", null, hasValidLink && (React.createElement(Box_1.Box, { margin: { top: 'xsmall' } },
                        React.createElement("div", null,
                            React.createElement(Link_1.Link, { href: actionLink.href || '#', onClick: actionLink.action, textUnderline: false }, actionLink.title))))))))); }));
    }
    return React.createElement("h1", null, "Component error - Please specify a card type");
};
/** @component */
exports.Card = recompose_1.compose(styled_components_1.withTheme)(CardInner);
//# sourceMappingURL=Card.js.map